var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResilienceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1976_14535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1976_14535)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0128 14.8427L18.8163 14.5022C18.7473 14.3826 18.7883 14.2297 18.9079 14.1607L20.356 13.3251C20.4755 13.2561 20.6284 13.2971 20.6974 13.4167L20.894 13.7572C20.963 13.8768 20.922 14.0297 20.8024 14.0987L19.3543 14.9343C19.2347 15.0033 19.0818 14.9623 19.0128 14.8427ZM19.8541 15.8004C19.2562 16.1455 18.4917 15.9405 18.1467 15.3425L17.9502 15.002C17.8563 14.8392 17.8031 14.6641 17.7875 14.4885C17.1637 14.6295 16.4948 14.3579 16.1582 13.7749L16.1084 13.6887C15.6942 12.9713 15.94 12.0539 16.6575 11.6397L19.428 10.0401C20.1454 9.62592 21.0628 9.87173 21.477 10.5892L21.5268 10.6754C21.8877 11.3005 21.7475 12.0775 21.2308 12.5411C21.3622 12.6395 21.4763 12.7656 21.5636 12.9168L21.7601 13.2574C22.1051 13.8553 21.9001 14.6198 21.3022 14.9648L19.8541 15.8004ZM17.0242 13.2749L16.9745 13.1887C16.8364 12.9496 16.9183 12.6438 17.1575 12.5057L19.928 10.9062C20.1671 10.7681 20.4729 10.85 20.611 11.0892L20.6608 11.1754C20.7988 11.4145 20.7169 11.7203 20.4777 11.8584L17.7073 13.4579C17.4681 13.596 17.1623 13.5141 17.0242 13.2749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16856 13.5038L3.43889 13.2183C3.53382 13.118 3.69205 13.1137 3.79231 13.2086L5.00634 14.3581C5.1066 14.453 5.11092 14.6112 5.01599 14.7115L4.74566 14.997C4.65073 15.0973 4.49249 15.1016 4.39223 15.0067L3.17821 13.8572C3.07795 13.7623 3.07363 13.604 3.16856 13.5038ZM2.49067 14.5833C1.98937 14.1087 1.96777 13.3175 2.44241 12.8162L2.71275 12.5307C2.8123 12.4256 2.92579 12.3415 3.0476 12.2787C2.47899 11.6966 2.47791 10.7637 3.05077 10.1802L3.12051 10.1092C3.70089 9.51805 4.65059 9.50932 5.24174 10.0897L7.52454 12.3309C8.11569 12.9113 8.12442 13.861 7.54404 14.4521L7.4743 14.5232C7.08415 14.9206 6.5271 15.0548 6.02428 14.9237C5.9688 15.096 5.87487 15.2589 5.74213 15.399L5.4718 15.6846C4.99715 16.1859 4.20599 16.2075 3.70469 15.7328L2.49067 14.5833ZM3.76435 10.8808L3.83409 10.8098C4.02755 10.6127 4.34411 10.6098 4.54116 10.8033L6.82396 13.0445C7.02101 13.2379 7.02392 13.5545 6.83046 13.7516L6.76072 13.8226C6.56726 14.0196 6.25069 14.0226 6.05365 13.8291L3.77085 11.5879C3.5738 11.3944 3.57089 11.0779 3.76435 10.8808Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11C17.3548 9.81483 15.2903 7.00002 12.1935 7.00002C8.32258 7.00002 6.5 10 6 11",
    stroke: "black",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResilienceIcon);
export default __webpack_public_path__ + "static/media/resilience_icon.b5260f32b09abf83c8aae9ef90d9a509.svg";
export { ForwardRef as ReactComponent };